import React from "react";
import FormRow from "../../components/formrow";
import { type Font, type GetSetValueProp } from "../models";
import BaseReactSelectDropdown from "components/dropdowns/reactselect/BaseReactSelectDropdown";

const FontDropdown = (props: GetSetValueProp<Font> & { options: Font[] }) => {
  const options = props.options.sort().map((val) => ({
    text: val,
    value: val
  }));

  return <FormRow label={RESX.EmbedWizard.Font}>
    <BaseReactSelectDropdown
      options={options}
      value={options.find(o => o.value === props.value)}
      onChange={o => { props.setValue(o.value); }}
      getLabel={item => item.text}
      getValue={item => item.value}
      excludeKeys={[]}
      config={{}}
    />
  </FormRow>;
};

export default FontDropdown;